<app-tree-controller
  (itemSelected)="itemSelected($event)"
></app-tree-controller>
